<template>
  <div class="page" :class="{ 'gem-mode': activeRechargeType === 'gems' }">
    <header class="recharge-header">
      <button class="recharge-brand" type="button" @click="goHome">
        <img src="@/img/logo.svg" alt="">
        <span>Yaychat</span>
      </button>
    </header>
    <div class="c_out">
      <div class="first-bg">
        <div class="card-title">{{ $t('recharge.firstTopUpGift') }}</div>
        <div class="card-description">{{ $t('recharge.firstTopUpGiftDescription') }}</div>
        <img src="@/img/recharge/recharge_gift.webp" alt="" class="gift-icon">
      </div>
      <div class="container">
        <div class="title">{{ $t('recharge.topUp') }}</div>
        <RechargeTypeTabs
          class="currency-tabs"
          :active="activeRechargeType"
          @change="switchRechargeType"
        />
        <div class="row" :class="{ 'without-user-id': !user_id }">
          <div class="desktop-account-section">
            <div class="desktop-account-label">{{ $t('recharge.userId') }}</div>
            <div class="desktop-account-card" :class="{ 'has-user': user }">
              <div class="desktop-input-wrap" :class="{ active: user }">
                <input
                  type="text"
                  v-model="user_id"
                  class="uid_input"
                  inputmode="numeric"
                  autocomplete="off"
                  @blur="saveUid"
                  @input="checkUid"
                  @keyup.enter="$event.target.blur()"
                  :placeholder="$t('recharge.enterUserIdToTopUp')"
                />
                <button
                  v-if="user_id"
                  class="clear-user-button"
                  type="button"
                  :aria-label="$t('recharge.clearUserId')"
                  @mousedown.prevent
                  @click="clearUserInput"
                >
                  <span aria-hidden="true"></span>
                </button>
              </div>
              <div v-if="user" class="desktop-user-info">
                <img :src="user.avatar" class="circle_avatar">
                <strong class="desktop-user-name">{{ user.nickName }}</strong>
                <span v-if="isNewUser" class="first-top-up">{{ $t('recharge.firstTopUp') }}</span>
              </div>
            </div>
          </div>


          <div v-if="showRechargeOptions || rechargeOptionsLoading" class="label">{{ $t('recharge.selectTopUpAmount') }}</div>
          <div v-if="productsLoading || rechargeOptionsLoading" class="value flex pc-coin-skeletons">
            <span v-for="index in 7" :key="index" class="pc-coin-skeleton skeleton-shimmer"></span>
          </div>
          <div v-else-if="showRechargeOptions" class="value flex">
            <div class="rechage_item flex-center" v-for="item in recharge_list" :key="item.id"
              :class="{
                active: item.id === select_recharge_id,
                disabled: activeRechargeType === 'gems' && !gemRechargeAllowed,
              }"
              :aria-disabled="activeRechargeType === 'gems' && !gemRechargeAllowed"
              @click="priceChangeHandle(item)">
              <div style="position: absolute;width: 150px;">
                <div class="flex-center row1" :class="{ active: item.id === select_recharge_id }">
                  <img v-if="activeRechargeType === 'gems'" src="@/img/gem/gem_icon.webp" alt="" class="gem-icon">
                  <img v-else src="@/img/jinbi.png" alt="">
                  {{ getRechargeAmount(item) }}
                </div>
              </div>

            </div>
          </div>
        </div>

        <div v-if="showPaymentOptions || productsLoading || rechargeOptionsLoading" class="row">
          <div class="label">{{ $t('recharge.confirmTopUp') }}</div>

          <div class="button-container">
            <template v-if="isPhilippineCoinUser && !isGuildGemUser && !productsLoading && !rechargeOptionsLoading">
              <div class="ph-coin-top-up-hint">{{ $t('recharge.philippineCoinTopUpHint') }}</div>
              <button
                type="button"
                class="guild-top-up-button ph-coin-top-up-button"
                :disabled="!canSubmitPhilippineCoins || !!clickPayItem"
                @click="philippineCoinTopUpClick"
              >
                <span v-if="clickPayItem" class="ph-coin-button-loading">{{ $t('recharge.paying') }}</span>
                <span v-else class="ph-coin-button-content">
                  <span class="ph-coin-button-action">{{ $t('recharge.topUp') }}</span>
                  <span class="payment-price">{{ select_recharge_item?.localPrice }}</span>
                  <span class="original-price">{{ getCoinOriginalPrice(select_recharge_item) }}</span>
                </span>
                <div
                  v-if="!clickPayItem && getPaymentDiscount(select_recharge_item?.supportedPayType)"
                  class="card_flag"
                ><span>{{ getPaymentDiscount(select_recharge_item?.supportedPayType) }}</span></div>
              </button>
            </template>
            <button
              v-else-if="isGuildGemUser"
              type="button"
              class="guild-top-up-button"
              :disabled="!select_recharge_item || clickPayItem"
              @click="guildGemTopUpClick"
            >
              <span v-if="clickPayItem">{{ $t('recharge.paying') }}</span>
              <span v-else class="gem-top-up-button-content">
                <span>Top-Up Now</span>
                <span>{{ getPaymentPrice(select_recharge_item) }}</span>
              </span>
            </button>
            <div v-else-if="productsLoading || rechargeOptionsLoading" class="pc-payment-skeletons">
              <span v-for="index in 3" :key="index" class="pc-payment-skeleton skeleton-shimmer"></span>
            </div>
            <!-- <div class="bank_card_btn" @click="bankCardClick">
              <div class="btn_con">
                <img src="@/img/ic_bank_card.svg" />
                Bank Card
                <span style="margin-left: 12px;">${{ select_recharge_item?.cent }}</span>
                <span class="raw-price">(${{ select_recharge_item?.coin / 50 }})</span>

                <div class="card_flag">
                  <span>37.5% OFF</span>
                </div>/
              </div>

            </div> -->

            <div v-for="item in directPayTypes" v-if="!isGuildGemUser && !isPhilippineCoinUser" :key="item" class="pay-method-item">
              <!-- <div v-if="item == 'STRIPE'" class="stripe-pay-btn" @click="stripePayClick"> -->
              <div v-if="['PAYERMAX', 'PAYERMAX_QRPH'].includes(item)" class="payermax-btn" @click="payermaxClick">
                <div class="inline-layout" :class="{ loading: clickPayItem == item }">
                  <div id="loadingSpinner" class="click-loading" v-if="clickPayItem == item"></div>
                  <img src="@/img/ic_payermax.svg" class="icon" />
                  <span>{{ $t('recharge.payermax') }}</span>
                  <span style="margin-left: 12px; font-style: normal;">{{ getPaymentPrice(select_recharge_item) }}</span>
                  <span v-if="activeRechargeType === 'coins'" class="raw-price">(${{ select_recharge_item?.coin / 50 }})</span>
                  <div v-if="activeRechargeType === 'coins'" class="card_flag">
                    <span>{{ $t('recharge.discount375Off') }}</span>
                  </div>
                </div>
              </div>
              <div v-else-if="item == 'STRIPE' || item == 'DIANDIAN'" class="stripe-pay-btn" @click="stripePayClick">
                <div class="inline-layout">
                  <div id="loadingSpinner" class="click-loading" v-if="clickPayItem == item"></div>
                  <img src="@/img/ic_stripe.svg" class="icon" />
                  <span class="gradient-text" style="padding: 0px 5px;">{{ clickPayItem == item ? $t('recharge.paying') : $t('recharge.stripePay') }}</span>
                  <span style="margin-left: 12px;color: #333; font-style: normal;">{{ getPaymentPrice(select_recharge_item) }}</span>
                  <span v-if="activeRechargeType === 'coins'" class="raw-price" style="color: #333;">(${{ select_recharge_item?.coin / 50 }})</span>
                </div>
                <div v-if="activeRechargeType === 'coins'" class="card_flag">
                  <span class="gradient-text" style="font-size: 11px;font-weight: 600;">{{ $t('recharge.discount375Off') }}</span>
                </div>
              </div>
              <div v-else-if="['PINGPONG', 'PINGPONG_QRPH'].includes(item)" class="stripe-pay-btn" @click="pingpongClick">
                <div class="inline-layout" :class="{ loading: ['PINGPONG', 'PINGPONG_QRPH'].includes(clickPayItem) }">
                  <div class="click-loading" v-if="['PINGPONG', 'PINGPONG_QRPH'].includes(clickPayItem)"></div>
                  <strong class="pingpong-logo">PingPong</strong>
                  <span style="margin-left: 12px;color: #333; font-style: normal;">{{ getPaymentPrice(select_recharge_item) }}</span>
                  <span v-if="activeRechargeType === 'coins'" class="raw-price" style="color: #333;">({{ getRechargePrice(select_recharge_item) }})</span>
                </div>
                <div v-if="activeRechargeType === 'coins'" class="card_flag">
                  <span class="gradient-text" style="font-size: 11px;font-weight: 600;">{{ $t('recharge.discount375Off') }}</span>
                </div>
              </div>
              <!-- <div v-else-if="item == 'ASIAPAY'" class="aisapay-btn" @click="asiapayClick">
                <div class="inline-layout">
                  <div id="loadingSpinner" class="click-loading" v-if="clickPayItem == item"></div>
                  <img src="@/img/paydollar.svg" class="paydollar-icon" />
                  <span>{{ clickPayItem == item ? "Paying..." : "Paydollar" }}</span>
                </div>
              </div>
              <div v-else-if="item == 'PAYPAL'">
                <div  id="top_up_btn"></div>
              </div> -->

            </div>

            <div v-if="!isGuildGemUser && !isPhilippineCoinUser && !productsLoading && showPaymentOptions && supportedPayTypes?.includes('PAYPAL')" class="pay-method-item">
              <div class="custom_paypal_btn" @click="customPaypalClick">
                <div class="btn_con">
                  <img src="@/img/ic_paypal.svg" />
                  <span class="gradient-text">{{ $t('recharge.paypal') }}</span>
                  <span style="margin-left: 12px; font-style: normal;">{{ getPaymentPrice(activeRechargeType === 'gems' ? select_recharge_item : paypal_product_item) }}</span>
                  <span v-if="activeRechargeType === 'coins'" class="raw-price">(${{ select_recharge_item.coin / 50 }})</span>
                  <div v-if="activeRechargeType === 'coins'" class="card_flag">
                    <span class="gradient-text" style="font-size: 11px;font-weight: 600;">{{ $t('recharge.discount285Off') }}</span>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="loading-overlay" v-if="loading">
    <div class="loader"></div>
    <span>{{ $t('recharge.coinsAreBeingDistributed') }}</span>
  </div>

  <div id="paypal-container"></div>

  <RechargeResultModal :result="rechargeResult" @close="closeRechargeResult" />

</template>

<script setup>
import router from '#/router'
import { computed } from 'vue'
import { useOumiRecharge } from './composables/useOumiRecharge'
import RechargeResultModal from './components/RechargeResultModal.vue'
import RechargeTypeTabs from './components/RechargeTypeTabs.vue'

const {
  loading,
  productsLoading,
  select_recharge_id,
  select_recharge_item,
  paypal_product_item,
  recharge_list,
  supportedPayTypes,
  user,
  user_id,
  isNewUser,
  clickPayItem,
  rechargeResult,
  activeRechargeType,
  gemRechargeAllowed,
  rechargeOptionsLoading,
  showRechargeOptions,
  showPaymentOptions,
  isGuildGemUser,
  isPhilippineCoinUser,
  canSubmitPhilippineCoins,
  philippineCoinTopUpClick,
  getPaymentDiscount,
  getCoinOriginalPrice,
  getRechargeAmount,
  getRechargePrice,
  getPaymentPrice,
  priceChangeHandle,
  checkUid,
  saveUid,
  clearUserInput,
  closeRechargeResult,
  switchRechargeType,
  guildGemTopUpClick,
  stripePayClick,
  payermaxClick,
  pingpongClick,
  customPaypalClick,
} = useOumiRecharge()

const renderedPayTypes = [
  'STRIPE',
  'DIANDIAN',
  'PAYERMAX',
  'PAYERMAX_QRPH',
  'PINGPONG',
  'PINGPONG_QRPH',
]

const directPayTypes = computed(() => (
  supportedPayTypes.value.filter(type => renderedPayTypes.includes(type))
))

function goHome() {
  router.push('/')
}
</script>

<style lang="scss" scoped>
/* 全局禁用横向滚动 */
* {
  box-sizing: border-box;
  max-width: 100%;
}

/* 确保根容器不会溢出 */
html,
body {
  overflow-x: hidden;
  max-width: 100%;
}

.page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(to right top, #4843FE, #FF5FB1);
  padding-top: 224px;
  box-sizing: border-box;
  padding-bottom: 100px;
  overflow-x: hidden;
}

.recharge-header {
  position: absolute;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #F1F1F1;
  background: #FFFFFF;
}

.recharge-brand {
  height: 36px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  color: #111111;
  background: transparent;
  font-family: "Poppins";
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;

  img {
    width: 36px;
    height: 36px;
    border-radius: 10px;
  }
}

.container {
  position: absolute;
  width: 100%;
  max-width: 100%;
  // min-height: 800px;
  background-color: white;
  // position: relative;
  // left: 0;
  // right: 0;
  // margin: 0 auto;
  // top: 200px;
  border-radius: 30px;
  padding: 20px;
  z-index: 4;
  box-sizing: border-box;
  overflow-x: hidden;
}

.c_out {
  position: relative;
  width: 60%;
  // min-height: 800px;
  // background-color: white;
  left: 0;
  right: 0;
  margin: 0 auto;
  // top: -100px;
  // // top: 200px;
  // border-radius: 30px;
  // padding: 20px;
  // z-index: 4;

}

.first-bg {
  position: absolute;
  z-index: 2;
  top: -128px;
  left: 0;
  width: 100%;
  height: 180px;
  padding: 28px 300px 0 48px;
  border-radius: 30px;
  color: #ffffff;
  background: linear-gradient(103deg, #0719ff 2%, #bb00ff 91%);

  .card-title {
    color: #FBEB03;
    font-size: 30px;
    font-weight: 900;
    line-height: 36px;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .card-description {
    max-width: 480px;
    font-size: 17px;
    font-weight: 500;
    line-height: 22px;
  }

  .gift-icon {
    position: absolute;
    top: -24px;
    right: 24px;
    width: 250px;
    height: auto;
  }
}

.rechage_item {
  position: relative;
  width: 150px;
  height: 80px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #F6F7F7;
  box-sizing: border-box;
  flex-direction: column;
  margin-right: 10px;
  margin-bottom: 10px;
  // flex: 1;
  // flex-shrink: 1;

  &.active {
    background:
      linear-gradient(110deg, #F9E8FF, #E9E6FF) padding-box,
      linear-gradient(110deg, #FF41FF, #6922FF) border-box;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.42;
    filter: grayscale(0.35);
  }

  .row1 {
    align-items: center;
    font-size: 25px;
    font-weight: 600;

    img {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }

    &.active {
      background-image: linear-gradient(#FF5FB1, #4843FE); // 背景线性渐变
      color: #ffffff; // 兜底颜色，防止文字裁剪不生效
      background-clip: text;
      -webkit-background-clip: text; // 背景被裁减为文字的前景色
      -webkit-text-fill-color: transparent; // 文字填充为透明，优先级比color高。
    }
  }

  .row2 {
    font-size: 18px;
    color: #999;
    font-weight: normal;
  }
}

.currency-tabs {
  margin: 0 auto 36px;
}

.gem-icon {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  object-fit: contain;
}

.pingpong-logo {
  color: #1679b7;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
}

.gem-mode {
  .raw-price,
  .card_flag {
    display: none;
  }
}

.pc-coin-skeletons {
  gap: 10px;
}

.pc-coin-skeleton {
  flex: 0 0 150px;
  width: 150px;
  height: 80px;
  border-radius: 12px;
}

.pc-payment-skeletons {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pc-payment-skeleton {
  width: 100%;
  height: 48px;
  border-radius: 30px;
}

.guild-top-up-button {
  display: block;
  width: 360px;
  max-width: 100%;
  height: 54px;
  margin: 0 auto;
  padding: 0;
  border: 0;
  border-radius: 27px;
  color: #ffffff;
  background: linear-gradient(90deg, #ff41ff 0%, #6922ff 100%);
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  cursor: pointer;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
}

.gem-top-up-button-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  white-space: nowrap;
}

.ph-coin-top-up-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3a2f00;
  background: linear-gradient(105deg, #fff86a 0%, #ffe24b 100%);
  box-shadow: 0 7px 20px rgba(255, 226, 75, 0.2);
  transition: filter 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:hover:not(:disabled) {
    box-shadow: 0 9px 24px rgba(255, 226, 75, 0.28);
    transform: translateY(-1px);
  }

  &:disabled {
    box-shadow: none;
  }
}

.ph-coin-button-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transform: translateY(-1px);
}

.ph-coin-button-action {
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.ph-coin-button-content .payment-price {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.ph-coin-button-content .original-price {
  color: rgba(58, 47, 0, 0.45);
  font-size: 13px;
  font-weight: 600;
  text-decoration: line-through;
  white-space: nowrap;
}

.ph-coin-button-loading {
  font-size: 14px;
  font-weight: 700;
}

// 与国际服支付按钮一致：复用卡片折扣丝带资源（flag_bank_card.webp）
.ph-coin-top-up-button .card_flag {
  width: 97px;
  height: 32px;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  right: 0;
  top: -20px;
  font-size: 11px;
  font-weight: 600;
  font-style: normal;
  color: #ffffff;
  background-image: url('../../assets/img/flag_bank_card.webp');
  background-size: cover;

  span {
    margin-top: 13px;
    margin-left: 28px;
    line-height: 16px;
  }
}

.ph-coin-top-up-hint {
  margin-bottom: 24px;
  color: rgba(51, 51, 51, 0.62);
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
}

.skeleton-shimmer {
  display: block;
  background: linear-gradient(100deg, #EEEEEE 25%, #FFFFFF 42%, #EEEEEE 59%);
  background-size: 220% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  font-family: "Poppins";
}

.row {
  margin-bottom: 30px;

  .label {
    font-size: 25px;
    font-weight: 600;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .value {
    flex-wrap: wrap;
  }
}

#top_up_btn {
  width: 100%;
}

.uid_input {
  width: 100%;
  height: 100%;
  padding: 0 42px 0 13px;
  border: 0;
  border-radius: 12px;
  outline: 0;
  color: #333333;
  background: transparent;
  font-size: 14px;
  font-weight: 700;

  &::placeholder {
    color: #C0C0C0;
    font-weight: 400;
    opacity: 1;
  }
}

.circle_avatar {
  flex: 0 0 32px;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.desktop-account-card {
  width: min(100%, 460px);
  min-height: 72px;
  margin: 0 auto;
  padding: 12px;
  border-radius: 16px;
  background: #F6F7F7;

  &.has-user {
    min-height: 116px;
    padding-bottom: 16px;
  }
}

.desktop-input-wrap {
  position: relative;
  height: 48px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #FFFFFF;

  &.active {
    border-color: #FF41FF;
  }
}

.clear-user-button {
  position: absolute;
  top: 50%;
  right: 13px;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #C8C8C8;
  transform: translateY(-50%);
  cursor: pointer;

  span::before,
  span::after {
    position: absolute;
    top: 8px;
    left: 4px;
    width: 10px;
    height: 2px;
    border-radius: 1px;
    background: #FFFFFF;
    content: '';
  }

  span::before {
    transform: rotate(45deg);
  }

  span::after {
    transform: rotate(-45deg);
  }
}

.desktop-user-info {
  height: 32px;
  margin: 8px 13px 0;
  display: flex;
  align-items: center;
  min-width: 0;
}

.desktop-user-name {
  min-width: 0;
  margin-left: 10px;
  overflow: hidden;
  color: #333333;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.first-top-up {
  flex: 0 0 auto;
  height: 20px;
  margin-left: 8px;
  padding: 0 7px;
  border-radius: 4px;
  color: #ffffff;
  background: linear-gradient(90deg, #FC1192, #FE8F19);
  font-size: 11px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
}

.user_title {
  margin-top: 10px;
  font-size: 14;
  font-weight: 600;
}

.coin_bg {
  position: absolute;
  right: -270px;
  top: -162px;
  z-index: 1;

  @media screen and (max-width: 767px) {
    display: none;
    /* 移动端隐藏装饰图片避免横向滚动 */
  }
}

@media screen and (max-width: 1200px) {
  .first-bg {
    padding-right: 230px;
    padding-left: 36px;

    .card-title {
      font-size: 24px;
      line-height: 31px;
    }

    .card-description {
      font-size: 15px;
      line-height: 20px;
    }

    .gift-icon {
      right: 12px;
      width: 215px;
    }
  }
}

.border-box {
  width: 100px;
  height: 40px;
  border: 4px solid transparent;
  border-radius: 25px;
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  background-image: linear-gradient(to right, #333, #333), linear-gradient(0deg, rgb(174, 111, 255) 0%, rgb(46, 179, 255) 100%);
}




@media screen and (max-width:767px) {
  .page {
    padding-top: 100px;
  }

  .c_out {
    width: 95%;
    max-width: 100%;
    min-height: calc(100vh - 100px);
    /* 增加可用空间 */
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .rechage_item {
    width: 46%;
  }

  .rechage_item:nth-child(2n) {
    margin-right: 0;
  }

  .container {
    padding: 15px;
    margin: 0;
  }

  /* 确保所有内容不会横向溢出 */
  .title,
  .label,
  .uid_input,
  .stripe-pay-btn,
  .payermax-btn,
  .custom_paypal_btn {
    max-width: 100%;
    box-sizing: border-box;
    word-wrap: break-word;
  }

  /* 确保按钮内容不溢出 */
  .inline-layout,
  .btn_con {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.payermax-btn {
  width: 100%;
  height: 48px;
  border: 1px solid transparent;
  border-radius: 30px;
  color: #333333;
  background:
    linear-gradient(90deg, rgba(72, 67, 254, 0.12) 0%, rgba(255, 75, 167, 0.12) 100%) padding-box,
    linear-gradient(#FFFFFF, #FFFFFF) padding-box,
    linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%) border-box;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 6px 0px;
  position: relative;

  .icon_suggest {
    width: 94px;
    height: 40px;
    position: absolute;
    right: 0;
    top: -30px;
  }


  .icon {
    height: 28px;
    width: 28px;
    margin-right: 8px;
  }

  .card_flag {
    width: 97px;
    height: 32px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    right: 0px;
    top: -20px;
    font-size: 11px;
    font-weight: 600;
    font-style: normal;
    color: white;
    background-image: url('../../assets/img/flag_bank_card.webp');
    background-size: cover;

    span {
      margin-top: 13px;
      margin-left: 28px;
      line-height: 16px;
    }
  }
}

.tt {
  width: 100%;
  height: 46px;
  object-fit: fill;
  background-color: #3498db;
}

.aisapay-btn {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 23px;
  background: #01B0F190;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 6px 0px;

}

.paydollar-icon {
  height: 24px;
  margin-right: 8px;
}

.stripe-pay-btn {
  width: 100%;
  height: 48px;
  border: 1px solid transparent;
  border-radius: 30px;
  background:
    linear-gradient(90deg, rgba(72, 67, 254, 0.12) 0%, rgba(255, 75, 167, 0.12) 100%) padding-box,
    linear-gradient(#FFFFFF, #FFFFFF) padding-box,
    linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%) border-box;
  color: #333;
  font-family: "Poppins";
  font-weight: 700;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-style: italic;
  margin: 6px 0px;
  position: relative;

  .icon_suggest {
    width: 94px;
    height: 40px;
    position: absolute;
    right: 0;
    top: -30px;
  }

  .icon {
    width: 28px;
    height: 28px;
    margin-right: 8px;
  }

  .card_flag {
    width: 83px;
    height: 18px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    right: 0px;
    top: -8px;
    font-size: 11px;
    font-weight: 600;
    font-style: normal;
    background-image: url('../../assets/img/flag_paypal.webp');
    background-size: cover;
  }

}


.inline-layout {
  display: inline-flex;
  justify-content: center;
  align-items: center;

  &.loading {
    opacity: 0.5;
  }

  span {
    color: white;
  }
}

// .stripe-pay-btn:hover {
//   opacity: 0.8;
// }

.stripe-pay-btn:active {
  background-color: #E1E1E1;
}

.loading-overlay {
  position: fixed;
  /* 固定定位 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明背景 */
  display: flex;
  flex-direction: column;
  color: white;
  font-size: 16px;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
  z-index: 1000;
  /* 确保它在最上面 */
}


/* Base style for the loader */
.loader {
  border: 5px solid #f3f3f3;
  /* Light grey border */
  border-top: 5px solid #3498db;
  /* Blue border */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin-bottom: 16px;
}

/* Animation for spinning effect */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes skeleton-shimmer {
  to {
    background-position-x: -220%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton-shimmer {
    animation: none;
  }
}

.button-container {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: "Poppins";
  font-weight: 700;
  font-style: italic;

  @media screen and (max-width: 767px) {
    max-height: 55vh;
    /* 增加最大高度以容纳更多支付方式 */
    overflow-y: auto;
    padding: 12px 0;
    -webkit-overflow-scrolling: touch;
    /* 平滑滚动 */

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(to bottom, #4843FE, #FF4BA7);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(to bottom, #5843FF, #FF4BF9);
    }

    /* 为更多支付方式优化显示 */
    .pay-method-item {
      margin-bottom: 8px;
      /* 减少间距以容纳更多选项 */
    }

    /* 添加底部渐变指示器，提示用户可以滚动 */
    &::after {
      content: "";
      position: sticky;
      bottom: 0;
      display: block;
      height: 20px;
      background: linear-gradient(to top, rgba(255, 255, 255, 0.9), transparent);
      pointer-events: none;
      z-index: 10;
    }
  }
}

.pay-method-item {
  width: 100%;
  margin-bottom: 10px;

  @media screen and (max-width: 767px) {
    margin-bottom: 12px;

    /* 确保按钮在小屏幕上有足够的触摸区域 */
    .stripe-pay-btn,
    .payermax-btn,
    .custom_paypal_btn {
      min-height: 48px;
      /* 稍微减少高度以容纳更多选项 */
      font-size: 14px;
      padding: 6px 12px;
      margin: 4px 0;

      /* 增强触摸反馈 */
      &:active {
        transform: scale(0.98);
        transition: transform 0.1s ease;
      }
    }

    /* 优化支付按钮内容布局 */
    .inline-layout {
      flex-wrap: nowrap;

      span {
        font-size: 14px;
      }
    }

    .btn_con {
      min-width: auto;

      span {
        font-size: 14px;
      }
    }
  }
}

.click-loading {
  border: 2px solid white;
  /* 浅灰色边框 */
  border-top: 2px solid #818181;
  /* 蓝色边框 */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  animation: spin 0.8s linear infinite;
  transform: translate(-50%, -50%);
}

.show-more {
  width: 100%;
  height: auto;
  min-height: 44px;
  transition: 0.3s;
  flex-direction: column;
  justify-content: start;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  span {
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
  }

  img {
    display: inline-block;
    width: 14px;
    height: 9px;
    margin-left: 6px;
  }
}

.long-box {
  min-height: 250px;
  transition: 0.3s;
}

.short-box {
  min-height: 80px;
  transition: 0.3s;
}

.rotate180 {
  transform: rotate(180deg);
}

.load-btn {
  position: absolute;
  bottom: 0;
  cursor: pointer;
}

// #top_up_btn {
//   position: absolute;
//   top: 50px;
// }

.op-trans {
  opacity: 1.0;
  transition: 0.6s;
}

.more-hidden-item {
  width: 100%;
  position: absolute;
  top: 0px;
  opacity: 0.0;

  &.show {
    opacity: 1.0;
    transition: 0.6s;
  }
}

.gradient-text {
  font-size: 16px;
  font-weight: 900;
  padding: 0px 5px;
  box-sizing: border-box;
  background-image: linear-gradient(to right, #4843FE, #FF4BA7); // 背景线性渐变
  color: #ffffff; // 兜底颜色，防止文字裁剪不生效
  background-clip: text;
  -webkit-background-clip: text; // 背景被裁减为文字的前景色
  -webkit-text-fill-color: transparent; // 文字填充为透明，优先级比color高。
}

.bank_card_btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 24px;
  color: white;
  font-weight: 600;
  display: flex;
  font-style: normal;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  font-size: 16px;
  position: relative;
  background: linear-gradient(to right, #4843FE, #FF4BA7); // 背景线性渐变;

  img {
    width: 24px;
    height: 20px;
    margin-right: 12px;
  }

  .card_flag {
    width: 97px;
    height: 32px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
      align-items: flex-start;
    right: 0px;
    top: -20px;
    font-size: 11px;
    font-weight: 600;
    background-image: url('../../assets/img/flag_bank_card.webp');
    background-size: cover;

    span {
      margin-top: 13px;
      margin-left: 28px;
      line-height: 16px;
    }
  }
}

.bank_card_btn:hover {
  background: linear-gradient(to right, #5843FF, #FF4BF9); // 背景线性渐变;
}

.bank_card_btn:active {
  opacity: 0.8;
}

.custom_paypal_btn {
  width: 100%;
  height: 48px;
  border: 1px solid transparent;
  border-radius: 30px;
  color: #ffffff;
  font-weight: 700;
  display: flex;
  font-style: italic;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin-bottom: 10px;
  position: relative;
  background:
    linear-gradient(90deg, rgba(72, 67, 254, 0.12) 0%, rgba(255, 75, 167, 0.12) 100%) padding-box,
    linear-gradient(#FFFFFF, #FFFFFF) padding-box,
    linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%) border-box;

  span{
    color: #333;
  }

  img {
    width: 28px;
    height: 28px;
    margin-right: 8px;
  }

  .card_flag {
    width: 83px;
    height: 18px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    right: 0px;
    top: -8px;
    font-size: 11px;
    font-weight: 600;
    font-style: normal;
    background-image: url('../../assets/img/flag_paypal.webp');
    background-size: cover;
  }
}

// .custom_paypal_btn:hover {
//   background-color: #4d2fcf;
// }

.custom_paypal_btn:active {
  opacity: 0.8;
}

.btn_con {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 185px;
}

/* 隐藏PayPal容器 */
#paypal-container {
  position: absolute;
  visibility: hidden;
  height: 0;
  width: 0;
  overflow: hidden;
}

.raw-price {
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0;
  color: white;
  text-decoration: line-through;
  margin-left: 5px;
}

@media screen and (min-width: 1081px) {
  .page {
    min-height: 100vh;
    padding: clamp(176px, 21vh, 240px) 32px 72px;
    background:
      linear-gradient(rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08)),
      url('@/img/recharge/yaychat_recharge_bg.webp') center / 100% 100% no-repeat,
      #F1EFFF;
  }

  .recharge-header {
    height: 96px;
    padding: 28px 64px 0;
    align-items: flex-start;
    border: 0;
    background: transparent;
  }

  .recharge-brand {
    height: 48px;
    gap: 14px;
    font-size: 28px;
    font-weight: 800;

    img {
      width: 48px;
      height: 48px;
      border-radius: 14px;
    }
  }

  .c_out {
    position: relative;
    width: min(1068px, calc(100vw - 64px));
    margin: 0 auto;
    left: auto;
    right: auto;
  }

  .first-bg {
    position: relative;
    z-index: 1;
    top: auto;
    left: auto;
    width: 100%;
    height: 176px;
    padding: 34px 410px 0 150px;
    border-radius: 48px 48px 0 0;
    background: linear-gradient(103deg, #0719FF 2%, #BB00FF 91%);

    .card-title {
      font-size: 30px;
      line-height: 36px;
    }

    .card-description {
      max-width: 500px;
      font-size: 16px;
      line-height: 21px;
      white-space: nowrap;
    }

    .gift-icon {
      top: -42px;
      right: 145px;
      width: 260px;
    }
  }

  .container {
    position: relative;
    z-index: 2;
    width: 100%;
    min-height: 624px;
    margin-top: -50px;
    padding: 66px 128px 48px;
    overflow: visible;
    border-radius: 48px;
    background: #FFFFFF;
  }

  .title {
    display: none;
  }

  .container > .row {
    margin: 0;
  }

  .desktop-account-section {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .desktop-account-label {
    margin-bottom: 14px;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  }

  .desktop-account-card {
    width: 480px;
    min-height: 48px;
    padding: 0;
    border-radius: 12px;
    background: transparent;

    &.has-user {
      height: auto;
      min-height: 116px;
      padding: 12px 12px 16px;
      box-sizing: border-box;
      border-radius: 16px;
      background: #F6F7F7;
    }
  }

  .desktop-input-wrap {
    height: 48px;
    border-radius: 12px;
    background: #F1F1F1;
  }

  .desktop-account-card.has-user .desktop-input-wrap {
    background: #FFFFFF;
  }

  .desktop-user-info {
    margin-right: 13px;
  }

  .container > .row:first-of-type > .label {
    margin: 44px 0 18px;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
  }

  .gem-mode .container > .row.without-user-id > .value {
    margin-top: 24px;
  }

  .value {
    width: 100%;
    display: grid !important;
    grid-template-columns: repeat(5, 150px);
    gap: 16px;
    justify-content: center;
  }

  .rechage_item,
  .pc-coin-skeleton {
    width: 150px;
    height: 100px;
    margin: 0;
    border-radius: 16px;
  }

  .rechage_item {
    background: #F1F1F1;

    > div {
      width: 150px !important;
    }

    .row1 {
      font-size: 24px;
      line-height: 29px;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .row2 {
      margin-top: 8px;
      color: #999999;
      font-size: 14px;
      line-height: 17px;
    }
  }

  .container > .row:last-of-type {
    margin-top: 36px;

    > .label {
      display: none;
    }
  }

  .button-container {
    width: 480px;
    margin: 0 auto;
  }

  .pc-payment-skeletons {
    gap: 12px;
  }

  .pc-payment-skeleton {
    height: 48px;
  }

  .pay-method-item {
    width: 100%;
    margin: 0 0 12px;
  }

  .stripe-pay-btn,
  .payermax-btn,
  .custom_paypal_btn {
    width: 100%;
    height: 48px;
    margin: 0;
    border: 1px solid transparent;
    border-radius: 30px;
    color: #222222;
    background:
      linear-gradient(90deg, rgba(72, 67, 254, 0.12) 0%, rgba(255, 75, 167, 0.12) 100%) padding-box,
      linear-gradient(#FFFFFF, #FFFFFF) padding-box,
      linear-gradient(90deg, #4843FE 0%, #FF4BA7 100%) border-box;
    box-shadow: none;
    font-style: normal;
  }

  .inline-layout,
  .btn_con {
    min-width: 0;
    justify-content: center;
    font-style: normal;

    > span {
      color: #111111;
      font-family: "Poppins";
      font-size: 14px;
      font-weight: 600;
      font-style: normal;
      line-height: 100%;
      letter-spacing: 0;
    }
  }

  .stripe-pay-btn .icon,
  .payermax-btn .icon,
  .custom_paypal_btn img {
    width: 28px;
    height: 28px;
  }

  .raw-price {
    color: rgba(51, 51, 51, 0.32) !important;
  }

  .pc-coin-skeleton,
  .pc-payment-skeleton {
    background: linear-gradient(100deg, #EEEEEE 25%, #FFFFFF 42%, #EEEEEE 59%);
    background-size: 220% 100%;
  }
}

@media screen and (min-width: 1081px) and (max-width: 1200px) {
  .container {
    padding-right: 80px;
    padding-left: 80px;
  }
}
</style>
